import React from 'react';
import SelectBox from 'devextreme-react/select-box';
import Validator, { RequiredRule } from 'devextreme-react/validator';
import './FormSelectBox.scss';

/* type SelectBoxProps = {
  value: string,
  label?: string,
  isEditing: boolean,
  onValueChange: (data) => void,
} */
/**
 * @typedef {object} SelectBoxProps
 * @property {string} value - The selected value.
 * @property {string} [label] - Optional label for the select box.
 * @property {boolean} isEditing - Whether the form is in editing mode.
 * @property {function(any): void} onValueChange - Callback when the value changes.
 * @property {function(any): void} onSelectionChanged - Callback with displayExpr and value when the value changes.
 * @property {Array|function} [dataSource] - Data source for the select box (can be array or async function).
 * @property {boolean} [readOnly] - Whether the select box is read-only.
 * @property {boolean} [required] - Whether the field is required.
 * @property {string} [valueExpr] - The field in the data source that provides the value.
 * @property {string} [displayExpr] - The field in the data source that provides the display label.
 * @property {boolean} [searchEnabled] - Whether search is enabled in the dropdown.
 * @property {string} [noDataText] - Text to display when no data is available.
 * @property {function(): void} [onOpened] - Callback when the dropdown is opened.
 * @property {React.ReactNode} [children] - Optional children nodes.
 */


/**
 * @param {SelectBoxProps} data
 */
export const FormSelectBox = ({
    value,
    label,
    isEditing,
    onValueChange = ()=> {},
    onSelectionChanged = ()=> {},
    dataSource,
    readOnly = false,
    required = false,
    valueExpr,
    displayExpr,
    searchEnabled,
    noDataText,
    onOpened,
    children,
    stylingMode = 'filled'
}) => {
    const isReadOnly = (readOnly, isEditing) => {
        if (readOnly) {
            return readOnly;
        }
        return !isEditing;
    };

    // Render a SelectBox with options where `SequenceNumber` is shown and `BuildingByCustomerId` is used as the value
    return (
        <div className="form-selectbox">
            <SelectBox
                label={label}
                value={value}
                dataSource={dataSource}
                valueExpr={valueExpr}  // Use BuildingByCustomerId as the value
                displayExpr={displayExpr}    // Display SequenceNumber as the label
                readOnly={isReadOnly(readOnly, isEditing)}
                elementAttr={{ class: 'form-editor' }}
                inputAttr={{ class: 'form-editor-input', 'aria-label': label }}
                stylingMode={stylingMode}
                onValueChange={onValueChange}
                onSelectionChanged={onSelectionChanged}
                searchEnabled={searchEnabled}
                noDataText={noDataText}
                onOpened={onOpened}
            >
                {/* Optional: Validator if the field is required */}
                {required &&
                    <Validator>
                        <RequiredRule message={ label + " is required."} />
                        {children}
                    </Validator>
                }
            </SelectBox>
        </div>
    );
};